import Vue from "vue";
import Vuetify from "vuetify";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";
import { abilitiesPlugin } from "@casl/vue";
import VueKonva from "vue-konva";

import ability from "./libs/acl/ability";
import router from "./router";
import store from "./store";
import App from "./App.vue";

// Global Components
import "./global-components";

// 3rd party plugins
import "@/libs/portal-vue";
import "@/libs/toastification";

// 既存コードにvuetifyを入れているのでインストールしておく
Vue.use(Vuetify);
// canvasを扱うためvueでラップしたkonvaライブラリを使用
Vue.use(VueKonva);

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;

// TODO: acl(libs/acl/indexの内容をここに登録)
Vue.use(abilitiesPlugin, ability);

new Vue({
    router,
    store,
    vuetify: new Vuetify(),
    render: h => h(App)
}).$mount("#app");
